import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AppUser } from "../domain/user.types";

export type UsersStatus = "idle" | "loading" | "succeeded" | "failed";

export interface UsersState {
  users: AppUser[];
  status: UsersStatus;
  error: string | null;
  /** The search term behind the current `users` list, or null for the unfiltered list. */
  lastSearch: string | null;
}

const initialState: UsersState = {
  users: [],
  status: "idle",
  error: null,
  lastSearch: null,
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    usersRequestStarted(state, action: PayloadAction<string | undefined>) {
      state.status = "loading";
      state.error = null;
      state.lastSearch = action.payload ?? null;
    },
    usersLoaded(state, action: PayloadAction<AppUser[]>) {
      state.users = action.payload;
      state.status = "succeeded";
    },
    usersRequestFailed(state, action: PayloadAction<string>) {
      state.status = "failed";
      state.error = action.payload;
    },
    userUpdated(state, action: PayloadAction<AppUser>) {
      const index = state.users.findIndex((user) => user.id === action.payload.id);
      if (index !== -1) state.users[index] = action.payload;
    },
    userAdded(state, action: PayloadAction<AppUser>) {
      state.users.push(action.payload);
    },
  },
});

export const { usersRequestStarted, usersLoaded, usersRequestFailed, userUpdated, userAdded } =
  usersSlice.actions;

export default usersSlice.reducer;
